export const BaseInputStyles = (
  expandstyles,
  width,
  bordered = false,
  fontSize = "1rem"
) => {
  return {
    control: (base) => ({
      ...base,
      border: bordered ? "1px solid var(--slim-grey)" : 0,
      borderRadius: "7px",
      boxShadow: "none",
      ...(width && { width }),
    }),
    menu: (base) => ({
      ...base,
      zIndex: 30,
      ...(width && { width }),
    }),
    input: (base) => ({
      ...base,
      fontSize: fontSize || "1rem",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: fontSize || "1rem",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    option: (base, { isDisabled, isFocused, isSelected }) => ({
      ...base,
      fontSize: fontSize || "1rem",
      color: isFocused || isSelected ? "var(--white)" : "var(--black)",
      backgroundColor:
        isFocused || isSelected ? "var(--electricblue)" : "var(--white)",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: fontSize || "1rem",
    }),
    noOptionsMessage: (base) => ({
      ...base,
      fontSize: fontSize || "1rem",
    }),
    ...expandstyles,
  };
};

export const OutlineInputStyles = (
  expandstyles,
  width,
  fontSize = "1rem",
  error = false,
  borderBottom = "2px solid var(--slim-grey)"
) => {
  return {
    control: (base) => ({
      ...base,
      border: 0,
      borderBottom: error ? "2px solid var(--error-dark)" : borderBottom,
      borderRadius: "0",
      boxShadow: "none",
      ...(width && { width }),
    }),
    menu: (base) => ({
      ...base,
      zIndex: 30,
      ...(width && { width }),
    }),
    input: (base) => ({
      ...base,
      fontSize: fontSize || "1rem",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: fontSize || "1rem",
      ...(error && { color: "var(--error-dark)" }),
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    option: (base, { isDisabled, isFocused, isSelected }) => ({
      ...base,
      fontSize: fontSize || "1rem",
      color: isFocused || isSelected ? "var(--white)" : "var(--black)",
      backgroundColor:
        isFocused || isSelected ? "var(--electricblue)" : "var(--white)",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: fontSize || "1rem",
    }),
    noOptionsMessage: (base) => ({
      ...base,
      fontSize: fontSize || "1rem",
    }),
    ...expandstyles,
  };
};
